import React from "react";
import {
  asDto,
  BaseWidgetProps,
  ItemBoxConfiguration,
  KeyInformationWidget,
  useKeyInformationData,
} from "shared-ui";
import { useApi } from "../../utils";
import {
  AssetsWarehouseOrdersWidgetClient,
  WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse,
} from "@lib/ShiOneClient";
import { DeviceUnknown, Inventory2, LocalShipping } from "@mui/icons-material";

const placeholderData = {
  success: true,
  isEmptyDataSet: false,
  data: {
    openTransfersOrders: 0,
    openIntegrationOrders: 0,
    openRackAndStackOrders: 0,
    totalOutgoingOrders: 0,
    totalShippedOrders: 0,
    rmaRequests: 0,
  },
};
function transformFunction(
  rawData:
    | WidgetContentResponseDto_1OfGetWarehouseAggregatedOrdersResponse
    | undefined,
): ItemBoxConfiguration[] {
  return [
    {
      amount: rawData?.data?.totalOutgoingOrders,
      label: "Orders In Progress",
      icon: <Inventory2 fontSize={"large"} />,
    },
    {
      amount: rawData?.data?.totalShippedOrders,
      label: "Shipped Orders",
      icon: <LocalShipping fontSize={"large"} />,
    },
    {
      amount: rawData?.data?.rmaOrders,
      label: "HLM Requests",
      icon: <DeviceUnknown fontSize={"large"} />,
    },
  ];
}
const useGetWarehouseOrdersData = () => {
  const api = useApi(AssetsWarehouseOrdersWidgetClient);

  return useKeyInformationData({
    queryKey: ["assets-warehouse-orders-widget"],
    apiFunction: () => api.getAssetsWarehouseOrdersWidgetData(),
    transformFunction: transformFunction,
    placeholderData: asDto(placeholderData),
  });
};

const AssetsWarehouseOrdersWidget: React.FC<BaseWidgetProps> = ({
  pageLayoutWidget,
}) => {
  return (
    <KeyInformationWidget
      pageLayoutWidget={pageLayoutWidget}
      useQueryFunction={useGetWarehouseOrdersData}
    />
  );
};
export default AssetsWarehouseOrdersWidget;
